<template>
	<div class="f-select inputfield inputfield--select" v-if="field">

		<MultiSelect
		v-if="field.multiple"
		v-model="value"
		:options="field.options"
		:disabled="systemdisable"
		:defaultValue="value"
		v-validate="getFieldValidation(field)" />
		<selectize
		v-else
		:multiple="false"
		:disabled="systemdisable"
		:autocomplete="field.autocomplete"

		v-model="value"
		v-validate="getFieldValidation(field)">
			<option v-for="opt in field.options" :key="opt.value" :value="opt.value">{{ (opt.translate ? $t(opt.label).trim() : opt.label) }}</option>
		</selectize>
		<div class="error" v-show="errors.has(field.name)">
			{{ errors.first(field.name) }}
		</div>
	</div>
</template>

<script>
import fieldvalidation from '@/helpers/fieldvalidation';
import Selectize from 'vue2-selectize';
import MultiSelect from '@/components/MultiSelect';

export default {
	name: 'f-select',
	components: {
    	Selectize,
    	MultiSelect
  	},
	data(){
		return {
			selected:''
		}
	},
	computed: {
		systemdisable(){
			let field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},
	  	value: {
		    get () {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		      	return field.value
		    },
		    set (value) {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		    	field.value = value;
		    }
		}
	},
	mounted(){
		if(this.field.value){
			this.selected = this.field.value;
		} else {
			this.selected = this.field.options[0].value;
		}
	},
	props: {
		field: {
			type: Object,
			default: function(){
				return {};
			}
		}
	},
	methods: {
		...fieldvalidation
	}
}
</script>



// WEBPACK FOOTER //
// src/components/form/f-select.vue